var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"900"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('tabla-detalles-de-pagos',{staticClass:"popup-pagos",attrs:{"pagos":_vm.adjuntos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }